import ShortenedTitle from "components/General-UI/ShortenedTitle";
import React from "react";

const NoEffices = ({ content, pinned }) => {
  return (
    <div className="text-item-wrapper">
      <div className="Txt-effice-no-branches">
        <div className="Txt-effice-no-branches-title">
          {pinned ? <ShortenedTitle title={content} maxChars={50} /> : null}
        </div>
        <div>
          {pinned ? "has no messages yet." : "this thread has no replies yet."}
        </div>
      </div>
    </div>
  );
};

export default NoEffices;
